import React, { useState } from "react"
import Image from "./image"
import { StaticImage } from "gatsby-plugin-image";

const ContentTestimonial = ({ data }) => {
    const testimonial_data = data; 
    return(
       <div className="max-w-5xl mt-16 m-auto bg-whiteColor-custom px-8 md:px-14 pt-16 pb-8 md:py-16 rounded-2xl border border-grayColor-priceCardBorder relative">
           <div className="quote-icon-svg absolute -top-8">
               <StaticImage src="../images/quote-blue-icon.svg" placeholder="tracedSVG" alt="icon" className="w-18 h-16" />
            </div>
           <p className="mt-0 mb-6 text-lg md:text-xl w-full lg:w-11/12 font-light">{testimonial_data.node.clientcontent}</p>
           <div className="flex items-center">
               <span className="client-image">
                   <Image props={testimonial_data.node.clientimage.asset._ref} classes="w-16 h-16 mt-0" />
               </span>
               <div className="ml-10">
                   <p className="client-name mt-0 text-sm md:text-lg"> - {testimonial_data.node.clientname}</p>
                   <p className="client-designation mt-0 text-sm md:text-lg">{testimonial_data.node.clientdesignation}</p>
               </div>
           </div>
       </div>
    )
}

export default ContentTestimonial